import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiArrowLeft } from "react-icons/fi";
import SEO from "../components/SEO";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="notfound blueprint">
      <SEO title={t("notFound.meta_title")} noindex />
      <div>
        <div className="code">{t("notFound.code")}</div>
        <h1>{t("notFound.title")}</h1>
        <p>{t("notFound.desc")}</p>
        <Link to="/" className="btn"><FiArrowLeft /> {t("notFound.cta")}</Link>
        <div className="nf-help">
          {t("notFound.help_pre")}
          <Link to="/iletisim">{t("notFound.help_link")}</Link>
          {t("notFound.help_post")}
        </div>
      </div>
    </div>
  );
}
